<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <div class="d-flex primary--text">
          <Icon
              class="pr-2"
              :name="text.toLowerCase()"
              :color="$vuetify.theme.themes.light.primary"
              :title="text"
          ></Icon>
          <!-- <span class="text-no-wrap">{{ text }}</span> -->
          <h3 class="text-no-wrap">{{ text }}</h3>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

import Icon from '@/components/UI/Icon.vue'
export default {
  name: "XsTitle",
  components: {Icon},
  props: {
    text: String,
  },
};
</script>
